var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-cloud-shape-wrapper" },
    [
      _c(_setup.ElementLibrarySelector, {
        attrs: {
          disabled: _setup.disabled,
          "element-list": _setup.model.shapeMap,
          "library-id": _setup.model.shapeLibraryId,
          "library-type": _setup.IMAGE_TYPE,
          "selected-position": _setup.model.shapeOption,
          "element-list-position": 3,
        },
        on: {
          "files-uploaded": _setup.onImageUpload,
          "load-option": _setup.updateOptionSelected,
          "options-reordered": _setup.onImageOptionsReordered,
          "remove-map-option": _setup.removeImageOptionFromMap,
          "remove-library": _setup.removeImageLibrary,
          "pick-library": function ($event) {
            return _setup.emit("open-shape-library-selector")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }